import { h, Component, RenderableProps } from "preact";

interface IRectProps {
  x: string;
  y: string;
  width: string;
  height: string;
  transform: string;
  fill: string;
  stroke: string;
}

interface IPathProps {
  d: string;
  fill: string;
  stroke: string;
  strokeLinejoin: string;
}

export interface IButtonProps {
  value: any;
  selected: boolean;
  disabled?: boolean;
  rectProps: IRectProps;
  pathProps?: IPathProps;
  onClick?: (value: any) => void;
}

interface IButtonState {
  hover?: boolean;
}

class Button extends Component<IButtonProps, IButtonState> {
  constructor(props?: IButtonProps, context?: any) {
    super(props, context);

    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onMouseOver(): void {
    if (this.props.disabled && this.state.hover === true) {
      this.setState({ hover: false });
    }

    if (this.props.disabled) {
      return;
    }

    if (!this.state.hover) {
      this.setState({ hover: true });
    }
  }

  onMouseOut(): void {
    if (this.state.hover) {
      this.setState({ hover: false });
    }
  }

  onClick(): void {
    if (this.props.disabled) {
      return;
    }
    this.props.onClick(this.props.value);
  }

  render(): JSX.Element {
    const {
      rectProps,
      pathProps,
      value,
      selected,
      disabled,
    }: RenderableProps<IButtonProps> = this.props;
    return (
      <g>
        <rect
          {...rectProps}
          style={disabled ? {} : { cursor: "pointer" }}
          className={
            (selected ? "is-active" : "") +
            (this.state.hover ? " is-highlighted" : "")
          }
          onClick={this.onClick}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
        />
        {!disabled && (
          <path
            {...pathProps}
            style={{ cursor: "pointer" }}
            onClick={this.onClick}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
          />
        )}
      </g>
    );
  }
}

export default Button;
